import { Type } from "@sinclair/typebox";
import SchemaValidator from "../schema-validator";
import { OptionalOrNull } from "../shared-schemas";

function StringLiteralUnion<T extends string>(values: T[]) {
	const literals = values.map((value) => Type.Literal(value));
	return Type.Union(literals);
}

const startProctoring = new SchemaValidator(
	Type.Object({
		sessionId: Type.String(),
	}),
);

const recordingBlobInfo = new SchemaValidator(
	Type.Object({
		proctoringSessionId: Type.String(),
		recordingType: Type.Union([Type.Literal("display"), Type.Literal("webcam")]),
		recordingNumber: Type.Number(),
		blobNumber: Type.Number(),
	}),
);
const uploadS3Url = new SchemaValidator(
	Type.Object({
		url: Type.String(),
	}),
);

const lmsContext = new SchemaValidator(
	Type.Object({
		institute: Type.Object({
			id: Type.Number(),
			origin: Type.String(),
			accessControlUuid: Type.String(),
		}),
		course: Type.Object({
			id: Type.Number(),
			courseId: Type.String(),
			accessControlUuid: Type.String(),
		}),
		assessment: Type.Object({
			id: Type.Number(),
			quizId: Type.String(),
		}),
	}),
);

const mediaAvailability = StringLiteralUnion(["unavailable", "processing", "available", "error"]);
const sessionStatus = StringLiteralUnion(["unflagged", "flagged", "incomplete", "pending", "error", "unavailable"]);
const videoAvailabilityList = Type.Object({
	available: Type.Array(Type.Union([Type.Number(), Type.String(), Type.Null()])),
	processing: Type.Array(Type.Union([Type.Number(), Type.String(), Type.Null()])),
	// error: Type.Array(Type.Number()),
});
const userInfo = Type.Object({
	username: OptionalOrNull(Type.String()),
	full_name: OptionalOrNull(Type.String()),
	given_name: OptionalOrNull(Type.String()),
	family_name: OptionalOrNull(Type.String()),
	email: OptionalOrNull(Type.String()),
	profile_picture: OptionalOrNull(Type.String()),
});

const testResults = new SchemaValidator(
	Type.Array(
		Type.Object({
			id: Type.Number(),
			studentId: Type.Number(),
			lmsQuizId: Type.Number(),
			uuid: Type.String(),
			screencaptureAvailability: mediaAvailability,
			webcamAvailability: mediaAvailability,
			screencaptureVideos: OptionalOrNull(videoAvailabilityList),
			webcamVideos: OptionalOrNull(videoAvailabilityList),
			idPhotoAvailable: Type.Boolean(),
			personPhotoAvailable: Type.Boolean(),
			userInfo: OptionalOrNull(userInfo),
			startTime: OptionalOrNull(Type.String()),
			endTime: OptionalOrNull(Type.String()),
			status: OptionalOrNull(sessionStatus),
			lmsQuizName: OptionalOrNull(Type.String()),
			createdAt: OptionalOrNull(Type.String()),
			realQuizId: OptionalOrNull(Type.String()),
			lmsUserId: OptionalOrNull(Type.String()),
			flagLevel: OptionalOrNull(Type.Number()),
			hasNotes: Type.Boolean(),
			hasRoomScanNotes: Type.Boolean(),
			isRoomScanDeleted: Type.Boolean(),
			isWebcamAndScreenCaptureDeleted: Type.Boolean(),
		}),
	),
);

const proctoringEvent = new SchemaValidator(
	Type.Object({
		events: Type.Array(
			Type.Object({
				type: Type.String(),
				name: Type.String(),
				details: Type.Record(Type.String(), Type.Any()),
				time: Type.String(),
				proctoringSessionId: Type.Number(),
				anomalyRef: OptionalOrNull(Type.Number()),
			}),
		),
		anomalies: Type.Array(
			Type.Object({
				type: Type.String(),
				flagLevel: Type.Number(),
				timeStart: OptionalOrNull(Type.String()),
				timeEnd: OptionalOrNull(Type.String()),
				id: Type.Number(),
				resolveComment: OptionalOrNull(Type.String()),
			}),
		),
	}),
);

const sessionNotes = new SchemaValidator(
	Type.Array(
		Type.Object({
			id: Type.Number(),
			content: Type.String(),
			timestamp: Type.String(),
		}),
	),
);

const roomScanNotes = new SchemaValidator(
	Type.Array(
		Type.Object({
			id: Type.Number(),
			content: Type.String(),
			timestamp: Type.Number(),
		}),
	),
);

const count = new SchemaValidator(Type.Number());

const concatenationRequestId = new SchemaValidator(Type.Object({ requestId: Type.String() }));

const concatenationRequest = new SchemaValidator(
	Type.Object({
		status: Type.Union([
			Type.Literal("POSTPROCESS_STARTED"),
			Type.Literal("POSTPROCESS_COMPLETE"),
			Type.Literal("POSTPROCESS_FAILED"),
		]),
	}),
);

const proctoringSession = new SchemaValidator(
	Type.Object({
		id: Type.Number(),
		uuid: Type.String(),
		studentId: Type.Number(),
	}),
);

export default {
	startProctoring,
	lmsContext,
	testResults,
	proctoringEvent,
	recordingBlobInfo,
	uploadS3Url,
	url: uploadS3Url,
	sessionNotes,
	roomScanNotes,
	count,
	concatenationRequestId,
	concatenationRequest,
	proctoringSession,
};
